import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Home from './Pages/Home/Home'
import ContactUs from './Pages/ContactUs/ContactUs'
import TheMoshiDifference from './Pages/TheMoshiDifference/TheMoshiDifference'
import WhatWeveDone from './Pages/WhatWeveDone/WhatWeveDone'
import WhatWeDo from './Pages/WhatWeDo/WhatWeDo'
import WebsiteDevelopment from './Pages/WhatWeDo/WebsiteDevelopment'
import BrandAndLogoDesign from './Pages/WhatWeDo/BrandAndLogoDesign'
import EcommerceandOnlineShops from './Pages/WhatWeDo/EcommerceandOnlineShops'
import GraphicDesign from './Pages/WhatWeDo/GraphicDesign'
import WebsiteAndNewsletterContentWriting from './Pages/WhatWeDo/WebsiteAndNewsletterContentWriting'
import WebsiteHosting from './Pages/WhatWeDo/WebsiteHosting'
import AppDevelopment from './Pages/WhatWeDo/AppDevelopment'
import SocialMediaMarketing from './Pages/WhatWeDo/SocialMediaMarketing'
import SocialMediaManagement from './Pages/WhatWeDo/SocialMediaManagement'
import GoogleAds from './Pages/WhatWeDo/GoogleAds'
import CustomProgrammedSystems from './Pages/WhatWeDo/CustomProgrammedSystems'
import PhotographyAndVideoShoots from './Pages/WhatWeDo/PhotographyAndVideoShoots'
import EmailNewsletterMarketing from './Pages/WhatWeDo/EmailNewsletterMarketing'
import DomainAddressRegistration from './Pages/WhatWeDo/DomainAddressRegistration'
import PublicRelations from './Pages/WhatWeDo/PublicRelations'
import VideoProductionAndAdvertising from './Pages/WhatWeDo/VideoProductionAndAdvertising'
import SearchEngineOptimisationSEO from './Pages/WhatWeDo/SearchEngineOptimisationSEO'

import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy'
import Offer from './Pages/Offer'
import Blog from './Pages/Blog/Blog'
import Nav from './Layout/Nav'
import Footer from './Layout/Footer'
import GAListener from './GAListener'


class App extends Component {
	render() {
		return (
			<Router>
				<GAListener>
					<div>
						<Nav />
						<Switch>
							<Route path="/" exact component={Home} />
							<Route path="/the-moshi-difference" exact component={TheMoshiDifference} />
							<Route path="/what-weve-done" component={WhatWeveDone} />
							<Route path="/what-we-do" component={WhatWeDo} />
							<Route path="/whatwedo/website-development" component={WebsiteDevelopment} />
							<Route path="/whatwedo/brand-and-logo-design" component={BrandAndLogoDesign} />
							<Route path="/whatwedo/graphic-design" component={GraphicDesign} />
							<Route path="/whatwedo/website-and-newsletter-content-writing" component={WebsiteAndNewsletterContentWriting} />
							<Route path="/whatwedo/website-hosting" component={WebsiteHosting} />
							<Route path="/whatwedo/app-development" component={AppDevelopment} />
							<Route path="/whatwedo/social-media-marketing" component={SocialMediaMarketing} />
							<Route path="/whatwedo/social-media-management" component={SocialMediaManagement} />
							<Route path="/whatwedo/google-ads" component={GoogleAds} />
							<Route path="/whatwedo/custom-programmed-systems" component={CustomProgrammedSystems} />
							<Route path="/whatwedo/photography-and-video-shoots" component={PhotographyAndVideoShoots} />
							<Route path="/whatwedo/email-newsletter-marketing" component={EmailNewsletterMarketing} />
							<Route path="/whatwedo/domain-address-registration" component={DomainAddressRegistration} />
							<Route path="/whatwedo/public-relations" component={PublicRelations} />
							<Route path="/whatwedo/video-production-and-advertising" component={VideoProductionAndAdvertising} />
							<Route path="/whatwedo/ecommerce-and-online-shops" component={EcommerceandOnlineShops} />
							<Route path="/whatwedo/search-engine-optimisation-seo" component={SearchEngineOptimisationSEO} />							
							<Route path="/privacy-policy" component={PrivacyPolicy} />
							<Route path="/blog" component={Blog} />
							<Route path="/contact-us" exact component={ContactUs} />
							<Route path="/sites" exact component={Offer} />
							<Route component={Home} />

						</Switch>
						<Footer />
					</div>
				</GAListener>
			</Router>
		);
	}
}



export default App;


// WEBPACK FOOTER //
// ./src/App.js